import { adminFetch } from '../../lib/adminFetch';
import React, { useState, useEffect } from 'react';

const SettingsAdmin = () => {
  const [allowedEmails, setAllowedEmails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminFetch('/api/admin-auth.php?action=settings')
      .then((r) => r.json())
      .then((data) => { if (data.success) setAllowedEmails(data.settings.allowedEmails || []); })
      .catch(() => {});
  }, []);

  const save = async (emails) => {
    setSaving(true);
    try {
      const res = await adminFetch('/api/admin-auth.php?action=update-settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ allowedEmails: emails }),
      });
      const data = await res.json();
      if (data.success) {
        setAllowedEmails(emails);
        setMessage('保存しました');
        setTimeout(() => setMessage(''), 2000);
      }
    } catch {}
    setSaving(false);
  };

  const addEmail = () => {
    if (!newEmail.trim() || !newEmail.includes('@')) return;
    if (allowedEmails.includes(newEmail.trim().toLowerCase())) return;
    save([...allowedEmails, newEmail.trim().toLowerCase()]);
    setNewEmail('');
  };

  const removeEmail = (email) => {
    if (allowedEmails.length <= 1) { setMessage('最低1つのメールアドレスが必要です'); return; }
    save(allowedEmails.filter((e) => e !== email));
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">設定</h2>

      {message && <div className="mb-4 px-4 py-2 bg-green-100 text-green-800 rounded-lg text-sm">{message}</div>}

      <div className="bg-white rounded-xl shadow p-6">
        <h3 className="font-bold text-lg mb-4">管理画面ログイン許可メールアドレス</h3>
        <p className="text-xs text-gray-500 mb-4">ここに登録されたメールアドレスのみ管理画面にログインできます。</p>

        <div className="flex gap-2 mb-4">
          <input type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)}
            placeholder="メールアドレスを追加"
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            onKeyDown={(e) => e.key === 'Enter' && addEmail()} />
          <button onClick={addEmail} disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-700 disabled:opacity-50">追加</button>
        </div>

        <div className="space-y-2">
          {allowedEmails.map((email) => (
            <div key={email} className="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-2">
              <span className="text-sm">{email}</span>
              <button onClick={() => removeEmail(email)}
                className="bg-red-50 text-red-600 px-3 py-1 rounded text-[10px] font-bold hover:bg-red-100">削除</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsAdmin;
